module.exports = __webpack_public_path__ + "static/media/31JFA1.02092a9c.jpg";